// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 872 ? "c58f5e3a" : chunkId) + "." + {"268":"d8ac54c6ddf7dbbd","647":"f4d2e1be8546b7ef","872":"c29fa3820f5ab59a"}[chunkId] + ".js";
};